import { useState } from 'react';
import { GuideContent } from './guide-content';
import { DocsContent } from './docs-content';
import { SubTabControl } from './sub-tab-control';

type HelpSubTab = 'tour' | 'docs';

const items = [
  { value: 'tour', label: 'Guided Tour' },
  { value: 'docs', label: 'Documentation' },
] as const;

/**
 * Help tab content — combines the guided tour and documentation under one tab.
 */
export function HelpContent() {
  const [active, setActive] = useState<HelpSubTab>('tour');

  return (
    <div className="flex h-full flex-col">
      <SubTabControl items={items} active={active} onChange={setActive} />
      <div className="min-h-0 flex-1 overflow-y-auto">
        {active === 'tour' && <GuideContent />}
        {active === 'docs' && <DocsContent />}
      </div>
    </div>
  );
}
